// 20 §9: every form records where the lead came from. The landing URL's utm_* / gclid values are kept for the
// session (sessionStorage), otherwise the referring site, otherwise "direct"; any <input data-mh-attribution>
// inside a form is filled with that string. The page-level source (topic, product, SKU) stays in contact[source].
(() => {
  const KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid'];
  const clean = (value) => String(value).replace(/[\u0000-\u001f<>]/g, '').slice(0, 120);
  let attribution = '';
  try {
    const params = new URLSearchParams(window.location.search);
    const found = KEYS.filter((key) => params.get(key)).map((key) => `${key}=${clean(params.get(key))}`);
    attribution = window.sessionStorage.getItem('mh_attribution') || '';
    if (found.length) {
      attribution = found.join('; ');
      window.sessionStorage.setItem('mh_attribution', attribution);
    } else if (!attribution) {
      let referrer = '';
      try {
        referrer = document.referrer ? new URL(document.referrer).hostname : '';
      } catch (error) {
        referrer = '';
      }
      attribution = referrer && referrer !== window.location.hostname ? `referrer=${clean(referrer)}` : 'direct';
      window.sessionStorage.setItem('mh_attribution', attribution);
    }
  } catch (error) {
    attribution = attribution || 'unknown';
  }
  const fill = () => {
    document.querySelectorAll('input[data-mh-attribution]').forEach((input) => {
      if (!input.value) input.value = attribution;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fill);
  else fill();
  document.addEventListener('shopify:section:load', fill);
})();
